import { clsx } from "@trydig/ui";
import type { ComponentProps } from "react";
import {
	AssetBlok,
	multiAssetToSingleAsset,
	sizes,
} from "@/components/bloks/Asset";
import { LinkWrapper } from "@/components/ui/LinkWrapper";
import type { BlokHero3, StoryblokMultiasset } from "@/storyblok";
import { Button } from "../../Button";
import styles from "./Hero3.module.css";

export interface Hero3Props
	extends Pick<
			BlokHero3,
			| "mainTitle"
			| "secondaryTitle"
			| "assetPadding"
			| "link"
			| "linkVariant"
			| "preamble"
		>,
		ComponentProps<"section"> {
	href?: string;
	linkText?: string;
	mainSource?: StoryblokMultiasset;
	lightMode?: boolean;
}

export const Hero3 = ({
	mainTitle,
	secondaryTitle,
	assetPadding,
	preamble,
	mainSource,
	link,
	href,
	linkText,
	linkVariant,
	className,
	lightMode,
	...rest
}: Hero3Props) => {
	const hasButton = linkText || href;
	return (
		<LinkWrapper href={href}>
			<section
				className={clsx(styles.root, className)}
				data-padding={assetPadding}
				{...rest}
			>
				<div className={styles.asset}>
					{mainSource?.length && (
						<AssetBlok
							source={multiAssetToSingleAsset(
								mainSource as unknown as StoryblokMultiasset,
							)}
							muted
							autoPlay
							loop
							priority
							quality={90}
							sizes={sizes(90, 80)}
						/>
					)}
				</div>
				<div className={styles.text} data-light={lightMode}>
					<h1 className={styles.title}>{mainTitle}</h1>
					<h2 className={styles.title}>{secondaryTitle}</h2>
					<p
						className={clsx(styles.preamble, !hasButton && styles.noLineClamp)}
					>
						{preamble}
					</p>

					<div className={styles.buttonWrapper}>
						<Button
							className={clsx(
								styles.button,
								linkVariant !== "default" && styles.link,
							)}
							style={{
								opacity: hasButton ? 1 : 0,
							}}
							href={href}
						>
							{linkText}
						</Button>
					</div>
				</div>
			</section>
		</LinkWrapper>
	);
};
